import { useEffect } from 'react'
import { useSignal, batch } from '@preact/signals-react'
import { postSubmit } from '@ui-seeker/utils'

import { isLoadingCommonFilters, commonFiltersValue, isSystemBusy } from '@signals'
import { WEBBACK_V2_API } from '@constants'
import { isEmptyAmazonReleaseDate, amazonReleaseDateSubmittedFilters } from "../@signals";


export default function useAmazonReleaseDateFilters() {

    const data = useSignal([])

    useEffect(() => {
        if (isLoadingCommonFilters.value) batch(() => {
            postSubmit(`${WEBBACK_V2_API}/custom-dash/amazon-release-date/context`, commonFiltersValue.value)
                .then(res => {
                    amazonReleaseDateSubmittedFilters.value = commonFiltersValue.peek()
                    if (!res?.length)
                        isEmptyAmazonReleaseDate.value = true
                    data.value = res
                    isLoadingCommonFilters.value = false
                })
                .catch(() => {
                    isSystemBusy.value = true
                    isLoadingCommonFilters.value = false
                })
        })
    }, [isLoadingCommonFilters.value])

    return {
        data: data.value
    }
}